import Vue from 'vue'
import VueMeta from 'vue-meta'
import VueMasonry from 'vue-masonry-css'
import VueCookies from 'vue-cookies'
import VueLazyload from 'vue-lazyload'
import { Swipe, SwipeItem } from 'vant'
import { initializeApp } from 'firebase/app'
import { getAnalytics, logEvent, isSupported } from 'firebase/analytics'
import { Message, Input, Divider } from 'element-ui'
import '@vant/touch-emulator'
import App from '@/App.vue'
import createRouter from '@/router'
import createStore from '@/store'
import '@/components' // 注册全局组件 Common 和 Btn
import global from '@/utils/global' // 全局函数
import commonMixin from '@/mixin/common.js' // 批量注册全局混入

const placeholderimage = require('@/assets/placeholder.png')

// 队列用于在 Analytics 初始化之前暂存事件
const eventQueue = []

Vue.use(VueCookies)
Vue.use(VueMasonry)
Vue.use(VueMeta)
Vue.use(Input)
Vue.use(Divider)
Vue.use(VueLazyload, {
	preLoad: 1.3,
	error: placeholderimage,
	loading: placeholderimage,
	attempt: 1,
})
Vue.use(Swipe).use(SwipeItem)

Vue.mixin(commonMixin)
Vue.prototype.$global = global
Vue.prototype.$message = Message
// 默认的 $logEvent 和 $eventrack 方法，将请求放入队列
Vue.prototype.$logEvent = (event, params = {}) => {
	console.log(`Queued log: ${event}`, params)
	eventQueue.push({ type: 'log', event, params })
}
Vue.prototype.$eventrack = (msg, method, map = {}) => {
	console.log(`Queued track: ${msg}`, method, map)
	eventQueue.push({ type: 'track', msg, method, map })
}

/** 初始化 Firebase */
function initializeFirebase() {
	const fconfig = window?.__INITIAL_STATE__?.domainConfig?.firebase || {}
	let app = initializeApp(fconfig)
	let analytics = getAnalytics(app)
	return analytics
}

/** 启用 Firebase 分析功能 */
function setupAnalytics() {
	isSupported().then((result) => {
		if (result) {
			const analytics = initializeFirebase()
			logEvent(analytics, 'in_page')
			console.log('in_page')

			// 覆盖默认的上报方法
			Vue.prototype.$logEvent = (event, params = {}) => {
				console.log(event)
				logEvent(analytics, event, params)
			}
			Vue.prototype.$eventrack = (msg, method, map = {}) => {
				let params = {
					time: new Date(),
					message: msg,
					method: method,
					...map,
				}
				console.log(msg)
				logEvent(analytics, msg, params)
			}
			// 处理广告点击
			Vue.prototype.$adClick = (message, routeName) => {
				const messageObj = JSON.parse(message)
				console.log(message)
				console.log('🚀🚀🚀 routeName: ', routeName)
				if (typeof JSCallAndroid !== 'undefined' && typeof JSCallAndroid.adClick === 'function') {
					JSCallAndroid.adClick(message)
				}
				const domainConfig = window?.__INITIAL_STATE__?.domainConfig || {}
				// 1. ttq
				const ttTrack = (id, eventType) => {
					console.log('tiktok track')
					ttq.track(eventType, {
						value: '100',
						currency: 'USD',
						contents: [
							{
								content_id: id,
								content_type: 'click',
								content_name: 'ad_iframe_click',
							},
						],
					})
				}
				if (domainConfig.pixelTrack) {
					ttTrack(messageObj.adSlot || '0000', 'ClickButton')
				}
				if (domainConfig.webwebUrl === 'pixel2magic.com' && routeName !== 'home') {
					requestAnimationFrame(() => {
						console.log('🚀🚀🚀 二次上报: ')
						ttTrack(messageObj.adSlot || '0000', 'ClickButton')
					})
				}
			}

			// 处理队列中的所有请求
			while (eventQueue.length > 0) {
				const queuedEvent = eventQueue.shift()
				if (queuedEvent.type === 'log') {
					Vue.prototype.$logEvent(queuedEvent.event, queuedEvent.params)
				} else if (queuedEvent.type === 'track') {
					Vue.prototype.$eventrack(queuedEvent.msg, queuedEvent.method, queuedEvent.map)
				}
			}
		} else {
			console.log('Firebase Analytics not supported')
		}
	})
}

if (typeof window !== 'undefined') {
	setupAnalytics()
} else {
	// 服务器端只定义简单的 log
	Vue.prototype.$logEvent = (event, params = {}) => {
		console.log(`Server Log: ${event}`, params)
	}
	Vue.prototype.$eventrack = (event, params = {}) => {
		console.log(`Server Log: ${event}`, params)
	}
	Vue.prototype.$adClick = (msg) => {
		console.log(`Server Log: ${msg}`)
	}
}

export default function createApp() {
	const store = createStore()
	const router = createRouter(store)
	const app = new Vue({
		router,
		store,
		render: (h) => h(App),
	})
	return {
		app,
		router,
		store,
	}
}
